import { Component, OnInit, ViewChild, ElementRef, Renderer2, Compiler } from '@angular/core';
import { Login, LoginData } from '../service/modal/login';
import { Globals } from '../globals';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { LoginService } from '../service/apiservice/login.service';
import { FormControl, Validators } from '@angular/forms';
import { UserService } from '../service/apiservice/user.service';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { pincode } from '../service/modal/pincode';
import { UtilFunctions } from '../util-functions';
import { SourceListMap } from 'source-list-map';
import { User, SessionUser } from '../service/modal/user';
import { UploadFileS3BucketService } from '../service/apiservice/uploadFileS3Bucket.service';
declare function info_noti(msg: any): any;
declare function alert(msg: any): any;
declare var $;

// import { HintService } from 'angular-custom-tour';
// import { TourService } from 'ngx-tour-md-menu';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from '../authenticate/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {





  genderControl = new FormControl('', [Validators.required]);
  @ViewChild('password') newpassword: ElementRef;

  // genders: String[] = ["None", "Male", "Female", "Other", "Transgender"];
  // bloodgroups: String[] = ["Don't Know", "A +ve", "A -ve", "B -ve", "B +ve", "AB -ve", "AB +ve", "O -ve", "O +ve"];
  //  // string array
  // myControl = new FormControl();
  // options: string[] = ['One', 'Two', 'Three'];
  // filteredOptions: Observable<string[]>;

  // picode filter using json array


  myControl = new FormControl();
  options;

  pincodeList: pincode[];
  filteredOptions: Observable<pincode[]>;
  selectedPincode;
  pincode;
  pincodefromFont: String;
  loginotp;
  countryDataCode = ['GB', 'US', 'DZ', 'AD', 'AO', 'AI', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BY', 'BE'
    , 'BZ', 'BJ', 'BM', 'BT', 'BO', 'BA', 'BW', 'BR', 'BN', 'BG', 'BF', 'BI', 'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'CL', 'CN', 'CO', 'KM'
    , 'CG', 'CK', 'CR', 'HR', 'CU', 'CY', 'CY', 'CZ', 'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FJ'
    , 'FI', 'FR', 'GF', 'PF', 'GA', 'GM', 'GE', 'DE', 'GH', 'GI', 'GR', 'GL', 'GD', 'GP', 'GU', 'GT', 'GN', 'GW', 'GY', 'HT', 'HN', 'HK'
    , 'HU', 'IS', 'IN', 'ID', 'IR', 'IQ', 'IE', 'IL', 'IT', 'JM', 'JP', 'JO', 'KZ', 'KE', 'KI', 'KP', 'KR', 'KW', 'KG', 'LA', 'LV', 'LB'
    , 'LS', 'LR', 'LY', 'LI', 'LT', 'LU', 'MO', 'MK', 'MG', 'MW', 'MY', 'MV', 'ML', 'MT', 'MH', 'MQ', 'MR', 'YT', 'MX', 'FM', 'MD', 'MC'
    , 'MN', 'MS', 'MA', 'MZ', 'MN', 'NA', 'NR', 'NP', 'NL', 'NC', 'NZ', 'NI', 'NE', 'NG', 'NU', 'NF', 'NP', 'NO', 'OM', 'PW', 'PA', 'PG'
    , 'PY', 'PE', 'PH', 'PL', 'PT', 'PR', 'QA', 'RE', 'RO', 'RU', 'RW', 'SM', 'ST', 'SA', 'SN', 'CS', 'SC', 'SL', 'SG', 'SK', 'SI', 'SB'
    , 'SO', 'ZA', 'ES', 'LK', 'SH', 'KN', 'SC', 'SD', 'SR', 'SZ', 'SE', 'CH', 'SI', 'TW', 'TJ', 'TH', 'TG', 'TO', 'TT', 'TN', 'TR', 'TM'
    , 'TM', 'TC', 'TV', 'UG', 'UA', 'AE', 'UY', 'UZ', 'VU', 'VA', 'VE', 'VN', 'VG', 'VI', 'WF', 'YE', 'YE', 'ZM', 'ZW']

  profileImgCharString: String[] = ['A.png', 'B.png', 'C.png', 'D.png', 'E.png', 'F.png', 'G.png', 'H.png', 'I.png', 'J.png', 'K.png', 'L.png', 'M.png', 'N.png', 'O.png', 'P.png', 'Q.png', 'R.png', 'S.png', 'T.png', 'U.png', 'V.png', 'W.png', 'X.png', 'Y.png', 'Z.png'];




  login: Login = new Login();
  userForm: User = new User();

  dependentForm: User = new User();
  mobileNoPresent: boolean;
  namePresent: boolean;
  otpPresent: boolean;
  incorrectpassowrd;
  heading: string
  user;
  mobileno;
  name;
  password;
  emailid;
  genratedOtp = 0;
  otpCheck;
  otpforlogincheck;
  nameforForgot;
  age;
  bloodgroupsDropDown: String[] = ["Don't Know", "A Positive", "A Negative", "B Negative", "B Positive", "AB Negative", "AB Positive", "O Negative", "O Positive"];
  bloodDropDown_SelectedId: number[];
  pincodeDropDown: any;
  pincodeDropDown_SelectedId: number[];
  genderDropDown: String[] = ["Male", "Female", "Other", "Transgender"];
  genderDropDown_SelectedId: number[];
  refrralcode;
  confirmpass;
  eyeIcon: string = "zmdi-eye-off";
  showpassword: boolean = false;
  @ViewChild('fname') private fname: ElementRef;
  showHideStatus: boolean = false;
  selectDegreeFile: File[] = [];
  selectRegNoFile: File[] = [];
  submitted: boolean = false;
  type: any;
  returnUrl: string;
  firstNameForOtp;




 
  constructor( private authenticate: AuthenticationService,private spinner: NgxSpinnerService,   private _compiler: Compiler, private _cookiesService: CookieService, private _userService: UserService,
    private global: Globals, private router: Router, private _loginService: LoginService,
    private renderer2: Renderer2, private uploadService: UploadFileS3BucketService) {

  }


  ngOnInit() {
    debugger
    // this.getAge('12/27/2018');




    this.loadEmptyUserForm();
    this.loadEmptyDependentForm();
    this.mobileNoPresent = false;
    this.namePresent = false;
    this.otpPresent = false;

    $(document).ready(function () {
      $('#addDependentUser').toggle();
      $('#dependentuser').toggle();
      $('#registerUser').toggle();
      $('#newRegisterSecondForm').toggle();
      $('#registerUserForPassword').toggle();
      $('#changePassword').toggle();
      $("#loginoptionId").toggle();
      $("#mobileNoPresent").toggle();
      $("#namePresent").toggle();
      $("#otpPresent").toggle();
      $("#doctorRegistration").toggle();
      $("#otherRegistration").toggle();
      $("#nextbutton").toggle();
      $("#registerbutton").toggle();
      $("#otpPresentEmergencyContactNo").toggle();

      $("#othernextbutton").toggle();
      $('#mobileNumber').show().focus();


    })

    this.heading = "SIGN IN / REGISTER";

    this.checkUserLoginOrNot();
  }

  checkUserLoginOrNot(){

   var buyNowButtonClick = UtilFunctions.getLocalStorage('BuyNowBtnStatus');
   if (this.authenticate.isUserLoggedIn()) {
     var user = UtilFunctions.getLocalStorage('LoggedInStatus');
     const activeRoute = localStorage.getItem('Active Route');
     if (user === '1') {
        
       if(buyNowButtonClick==='true'){
         this.global.buyNowButtonClick=true;
    //  alert("buton true")
       }
       this.router.navigate(['dashboard']);
       this.global.loginCount = 1;
     }
   } else {
     if(buyNowButtonClick==='true'){
       this.global.buyNowButtonClick=true;
      //  alert("button true with login")
     }
    //  this.router.navigate(['login']);
   }

  }
  checkMobileNo(event, mobileno, check) {
    this.mobileno = mobileno;
    if (this.userForm.mobileNumber.length <= 9) {
      $('#registerUser').hide()
      // $('#firstName1').hide()
      $("#mobileNoPresent").hide();
      $("#loginoptionId").hide();
      $("#otpPresent").hide();
      $("#otpPresentEmergencyContactNo").hide();
      $("#namePresent").hide();
      $('#dependentuser').hide();
      $('#registerUserForPassword').hide();
      $("#doctorRegistration").hide();
      $("#otherRegistration").hide();

      this.userForm.firstName = '';
      this.heading = "SIGN IN / REGISTER";
      this.mobileNoPresent = false;
      // $(document).ready(function () {
      //   $("#mobileNumber").keypress(function (e) {
      //     if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
      //       $("#errmsg").html("Digits Only").show().fadeOut("slow");
      //       return false;
      //     }
      //   });
      // });
      // return false
    }


    if (this.userForm.mobileNumber != "" && this.userForm.mobileNumber.length == 10) {
      this._loginService.VerifyMobileNo(mobileno)
        .subscribe((response) => {
       
          //  alert(response)
          if (response === 'Present') {
            // this.mobileNoPresent = true;
            $("#mobileNoPresent").show();
            this.heading = "SIGN INTO YOUR ACCOUNT";
            $('#registerUser').hide().attr("formnovaildate");
            $("#firstName").show().focus();

          } else if(response === 'Invalid Mobile Number'){
         console.log("Invalid Mobile Number Please Enter Valid Number");
            info_noti("Invalid Mobile Number Please Enter Valid Number");

          }else{
            this.selectedPincode = "";
            this.heading = "REGISTER A NEW ACCOUNT";
            // this.mobileNoPresent = false;
            $("#mobileNoPresent").hide();
            // this.namePresent = false;
            $("#namePresent").hide();
            $('#registerUserForPassword').hide();
            $('#dependentuser').hide();
            $('#registerUser').show();
            $('#firstName1ForRegisterUser').show().focus();
            if (check == 'mobileno') {
              this.mobileno;
            }
            this.emailid = this.mobileno + "." + "@mdhl.in"
            $("#emailAddress").val(this.emailid);
            $("#emailAddress1").val(this.emailid);
          }


        }, error => {
          console.log(error);
        });
    }



  }

  //enter event call also
  checkName(name, check,key) {
    debugger;
    this.name = name;
    if (this.name != "" && this.name.length > 0) {
    //  if(key==='enterkey'){
    //   $("#middlename2").focus();
    //  }else{

      this._loginService.VerifyName(this.name, this.mobileno)
        .subscribe((response) => {
        
          if (response == 'Present') {
            // this.namePresent = true;
            $("#namePresent").show();
            $('#changePassword').hide().attr("formnovaildate");
            // $('#addDependentUser').hide().attr("formnovaildate");
            // $('#dependentuser').hide().attr("formnovaildate");
            $('#dependentuser').hide();

            // $("#addDependentUserModel").modal("hide");
            $('#registerUserForPassword').hide();
            $("#loginoptionId").show();
            $('#password').focus();
          } else if (response == 'Password Not Independent') {
            // this.namePresent = false;
            $("#namePresent").hide();
            $('#registerUserForPassword').show();
            $('#middleNameforpassword').focus();
            $('#dependentuser').hide();
            $("#loginoptionId").hide();
            if (check == 'mobileno') {
              this.mobileno;
            }
            this.emailid = this.mobileno + "." + this.name.toLowerCase() + "@mdhl.in"
            $("#emailAddress").val(this.emailid);
            $("#emailAddress1").val(this.emailid);
            this.userForm.emailAddress = this.emailid;
            $("#middleNameforpassword").focus();

         

          }else if(response == 'Password Not Dependent'){

            $("#namePresent").hide();
            //show toggle
            $("#middlename2").focus();
            $("#firstname2").val(this.name);
            this.emailid = this.mobileno + "." + this.name.toLowerCase() + "@mdhl.in"
            this.dependentForm.firstName = this.name;
            this.dependentForm.emailAddress = this.emailid;
            $("#loginoptionId").hide();
            $('#dependentuser').show();
            $('#registerUserForPassword').hide();
            $('#registerUser').hide();
            this.firstNameForOtp = name;
            this._loginService.GenerateOtp(this.mobileno, name, 'registration at').subscribe((response) => {
              this.genratedOtp = response.otp_id;
            }, error => {

            });


          } else if(response == 'Not Present'){
            
            $("#namePresent").hide();
            //show toggle
            $("#middlename2").focus();

            $("#firstname2").val(this.name);
            this.emailid = this.mobileno + "." + this.name.toLowerCase() + "@mdhl.in"
            this.dependentForm.firstName = this.name;
            this.dependentForm.emailAddress = this.emailid;
            $("#loginoptionId").hide();
            $('#dependentuser').show();
            $('#registerUserForPassword').hide();
            $('#registerUser').hide();
            this.firstNameForOtp = name;
            this._loginService.GenerateOtp(this.mobileno, name, 'registration at').subscribe((response) => {
              this.genratedOtp = response.otp_id;
            }, error => {

            });

          }
        }, error => {
          console.log(error);
        });
    //  }

    }

  }

  radiobuttonChecked(event) {

    this.submitted = false;
    console.log(event.target.otp);
    if (event.target.value == 'otp') {
      this._loginService.GenerateOtp(this.mobileno, this.name, 'Otp Login').subscribe((response) => {
        this.genratedOtp = response.otp_id;
      }, error => {

      });
      $('#changePassword').hide().attr("formnovaildate");
      $("#otpPresent").show();
      $("#otpPresentEmergencyContactNo").hide();
      $("#namePresent").hide();
      $('#loginOtp').focus();
    }
    if (event.target.value == 'password') {
      $('#changePassword').hide().attr("formnovaildate");
      $("#namePresent").show();
      $("#otpPresent").hide();
      $("#otpPresentEmergencyContactNo").hide();
      $('#password').focus();

    }
    if (event.target.value == 'otpEmergencyContactNo') {

      //check Emgency Contact No Present Or Not
      this._loginService.GenerateOtp(this.mobileno, this.name, 'Login EmergencyContactNo').subscribe((response) => {
        if (response.message === 'Emergency Contact No Not Present') {
          alert("Emergency Contact Number Not Added  Please Login With Otp")
        } else {
          this.genratedOtp = response.otp_id;
        }
      }, error => {

      });
      $('#changePassword').hide().attr("formnovaildate");
      $("#otpPresentEmergencyContactNo").show();
      $("#otpPresent").hide();
      $("#namePresent").hide();
      $('#otpPresentEmergencyContactNo').focus();
    }

  }


  checkpassword(pasword) {
    this.password = pasword;

    // var mobileno=mobileno1.split(" ")[1];
    // if (this.name != "") {
    //   this._loginService.VerifyPassword(this.name, this.mobileno, pasword)
    //     .subscribe((response) => {
    //       //  alert(response);
    //       Object.assign(this.global.loggedUser, response);
    //       console.log(this.global.loggedUser);
    //       UtilFunctions.setLocalStorage('user', JSON.stringify(response));
    //       this.router.navigate(['dashboard']);

    //     }, error => {
    //       this.incorrectpassowrd = "incorrect Password";
    //       console.log(error);
    //     });
    // }
  }
  checkOptForLogin(otp) {
    this.loginotp = otp;
    this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
      this.otpforlogincheck = response;
    }, error => {

    });

  }
  LoginClick(login) {

    if (this.name != "") {
      if (login == 'passwordlogin') {

        this.submitted = true;
        if (this.userForm.mobileNumber != '' && this.userForm.firstName != '' && this.userForm.password != '') {
          this._loginService.VerifyPassword(this.name, this.mobileno, this.password, 'passwordlogin')
            .subscribe((response) => {

              Object.assign(this.global.loggedUser, response);

              // console.log(this.global.loggedUser);

              UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
              UtilFunctions.setLocalStorage('isLoggedIn', "true");
              UtilFunctions.setLocalStorage('LoggedInStatus', 1);
              // this.router.navigate(['dashboard']);

              if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise'  || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {
                this.router.navigate(['doctordashboard']);
              } else if (this.global.loggedUser.user.role == 'patient' || this.global.loggedUser.user.role == null) {
                this.router.navigate(['dashboard']);
                // this.router.navigate([this.returnUrl]);
              }


            }, error => {
              //   Lobibox.notify('success', {
              //     // pauseDelayOnHover: true,
              //     size: 'mini',
              //     rounded: true,
              //     icon: 'fa fa-check-circle',
              //     delayIndicator: false,
              // continueDelayOnInactiveTab: false,
              //     position: 'top middle',
              //     msg: 'Email Sent To Customer Successfully.'
              //     });
              // alert('Sorry, something Went Wrong. Please try again');
              // Lobibox.notify('error', {
              //   pauseDelayOnHover: true,
              //  continueDelayOnInactiveTab: false,
              //   position: 'top middle',
              //   icon: 'fa fa-times-circle',
              //   msg: 'incorrect Password.'
              //   });

              alert("incorrect Password");
              // this.incorrectpassowrd = "incorrect Password";
              console.log(error);
            });
          this.submitted = false;
        }
      }
      if (login == 'otpLogin') {
        if (this.otpCheck === 'Otp Not Match' || this.otpCheck === 'Expired Otp') {

        }else{

          this.submitted = true;
          if (this.userForm.mobileNumber != '' && this.userForm.firstName != '' && this.userForm.otp != '') {
  
            this._loginService.VerifyPassword(this.name, this.mobileno, this.loginotp, 'otpLogin')
              .subscribe((response) => {
                //  alert(response);
                Object.assign(this.global.loggedUser, response);
                // console.log(this.global.loggedUser);
                UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
                UtilFunctions.setLocalStorage('isLoggedIn', "true");
                UtilFunctions.setLocalStorage('LoggedInStatus', 1);
                if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise' || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {
                  this.router.navigate(['doctordashboard']);
                } else if (this.global.loggedUser.user.role == 'patient' || this.global.loggedUser.user.role == null) {
                  this.router.navigate(['dashboard']);
                }
              }, error => {
                // Lobibox.notify('error', {
                //   pauseDelayOnHover: true,
                //  continueDelayOnInactiveTab: false,
                //   position: 'top middle',
                //   icon: 'fa fa-times-circle',
                //   msg: 'incorrect Password.'
                //   });
  
                alert("incorrect Password");
                // this.incorrectpassowrd = "incorrect Password";
                console.log(error);
              });
            this.submitted = false;
          
        }
        }
    
      }
    }


  }
  registerationNextClick() {
    console.log(this.userForm);
    this.submitted = true;
    if (this.userForm.firstName != '' && this.userForm.pinCode != '' && this.userForm.emailAddress != '') {
      $("#registerbutton").show();
      $('#newRegisterFirstForm').hide().attr("formnovaildate");
      $('#newRegisterSecondForm').toggle();
      $('#passwordNewRegister').focus();

      ///generate otp
      this._loginService.GenerateOtp(this.mobileno, this.userForm.firstName, "Not ChangePassword").subscribe((response) => {
        // console.log(response);

        this.genratedOtp = response.otp_id;

      }, error => {

      });
      this.submitted = false;
    }

    // userForm.submitted && firstName.invalid



  }


  setEmailId(name, check) {
    if (check == 'mobileno') {
      this.mobileno;
    }
    this.emailid = this.mobileno + "." + name.toLowerCase() + "@mdhl.in"
    this.userForm.emailAddress = this.emailid;
    $("#emailAddress1").val(this.emailid);
    $("#emailAddress").val(this.emailid);
  }
  registerationUser() {
    console.log(this.userForm)
    // var mobilno = this.mobileno;
    // var name = this.name;
    // this.userForm.age = this.age;

    // console.log(this.userForm.role);
    this.submitted = true;
    if (this.userForm.role == undefined || this.userForm.role == 'patient') {
      if (this.userForm.password != '' && this.userForm.confirmpassword != '' && this.userForm.otp != '' && this.userForm.gender != '') {
        this.spinner.show()

        this.userForm.role = 'patient';
        // this.userForm.postalAddress = this.selectedPincode;
        // this.userForm.pinCode = this.pincode;
        // console.log(this.user);
        this.userForm.emailAddress = this.userForm.mobileNumber + "." + this.userForm.firstName.toLowerCase() + "@mdhl.in";
        var firstletter = this.userForm.firstName.charAt(0);

        var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
        for (let i = 0; i < this.profileImgCharString.length; i++) {
          // console.log(this.profileImgCharString[i].charCodeAt(0))
          var first = this.profileImgCharString[i].split(".")[0];
          if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
            profileImgPath = profileImgPath + this.profileImgCharString[i];
            break;
          }
        }
        this.userForm.profileImgPath = profileImgPath;

        //  this.userForm.doctor.aadharCard= this.userForm
        //  this.userForm.doctor.gst
        //  this.userForm.doctor.panCard
        // //  this.userForm.doctor.photo
        //  this.userForm.doctor.registrationNo
        //  this.userForm.doctor.remark
        //  this.userForm.doctor.gst
        //  this.userForm.doctor.speciality
        //  this.userForm.doctor.yearOfCommencement


        this._userService.registerUser(this.userForm)
          .subscribe((response) => {
            this.spinner.hide();
            alert("Registration Successfully");

            // $('#newRegisterSecondForm').hide().attr("formnovaildate");
            $('#newRegisterSecondForm').hide().attr("formnovaildate");
            $('#registerUser').hide().attr("formnovaildate");

            $('#newRegisterFirstForm').toggle();
            // this.name = false;
            this.mobileno = false;
            this.userForm = new User();
            this.selectedPincode = "";
            UtilFunctions.setLocalStorage('user', JSON.stringify(response));
            this.global.loggedUser = response;

            if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise' || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {
              this.router.navigate(['doctordashboard']);
            } else if (this.global.loggedUser.user.role == 'patient' || this.global.loggedUser.user.role == null) {
              this.router.navigate(['dashboard']);
            }

            // this.router.navigate(['dashboard']);
            // this.addForm.resetForm();
            // this.addCloseForm.nativeElement.click();
          },
            error => {
              this.spinner.hide()
              alert("User Not Registered");
            })
        this.submitted = false;
      }
    } else if (this.userForm.role == 'doctor') {

      this.submitted = true;
      if (this.userForm.speciality != '' && this.userForm.degree != '' && this.userForm.regno != '' && this.userForm.degreeCertificatePath != '' && this.userForm.regnoCertificatePath != '') {
        this.spinner.show()
        // this.userForm.postalAddress = this.selectedPincode;
        // this.userForm.pinCode = this.pincode;

        this.userForm.emailAddress = this.userForm.mobileNumber + "." + this.userForm.firstName.toLowerCase() + "@mdhl.in";
        var firstletter = this.userForm.firstName.charAt(0);

        var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
        for (let i = 0; i < this.profileImgCharString.length; i++) {
          // console.log(this.profileImgCharString[i].charCodeAt(0))
          var first = this.profileImgCharString[i].split(".")[0];
          if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
            profileImgPath = profileImgPath + this.profileImgCharString[i];
            break;
          }
        }
        this.userForm.profileImgPath = profileImgPath;
        this._userService.registerUser(this.userForm)
          .subscribe((response) => {
            UtilFunctions.setLocalStorage('user', JSON.stringify(response));
            this.global.loggedUser = response;
            if (this.selectDegreeFile.length > 0) {
              this.uploadService.uploadfile(this.selectDegreeFile, "");
            }
            if (this.selectRegNoFile.length > 0) {
              this.uploadService.uploadfile(this.selectRegNoFile, "");
            }



            this.spinner.hide()
            alert("Registration Successfully");
            // $('#newRegisterSecondForm').hide().attr("formnovaildate");
            $('#newRegisterSecondForm').hide().attr("formnovaildate");
            $('#registerUser').hide().attr("formnovaildate");

            $('#newRegisterFirstForm').toggle();
            this.name = false;
            this.mobileno = false;
            this.userForm = new User();
            this.selectedPincode = "";

            if (this.global.loggedUser.user.role == 'doctor' || this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise' || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate' || this.global.loggedUser.user.role == 'other') {
              this.router.navigate(['doctordashboard']);
            } else if (this.global.loggedUser.user.role == 'patient' || this.global.loggedUser.user.role == null) {
              this.router.navigate(['dashboard']);
            }
            // this.addForm.resetForm();
            // this.addCloseForm.nativeElement.click();
          },
            error => {
              this.spinner.hide()
              alert("User Not Registered");
            });
        this.submitted = false;
      }

    } else {
      this.submitted = true;
      // if (this.userForm.speciality != '' && this.userForm.degree != '' && this.userForm.regno != '' && this.userForm.degreeCertificatePath != '' && this.userForm.regnoCertificatePath != '') {
      this.spinner.show()
      // this.userForm.postalAddress = this.selectedPincode;
      // this.userForm.pinCode = this.pincode;

      this.userForm.emailAddress = this.userForm.mobileNumber + "." + this.userForm.firstName.toLowerCase() + "@mdhl.in";
      var firstletter = this.userForm.firstName.charAt(0);

      var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
      for (let i = 0; i < this.profileImgCharString.length; i++) {
        // console.log(this.profileImgCharString[i].charCodeAt(0))
        var first = this.profileImgCharString[i].split(".")[0];
        if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase().toString()) {
          profileImgPath = profileImgPath + this.profileImgCharString[i];
          break;
        }
      }
      this.userForm.profileImgPath = profileImgPath;




      this._userService.registerUser(this.userForm)
        .subscribe((response) => {
          UtilFunctions.setLocalStorage('user', JSON.stringify(response));
          this.global.loggedUser = response;
          this.spinner.hide()
          // console.log(this.selectDegreeFile);
          // console.log(this.selectRegNoFile);

          if (this.selectDegreeFile.length > 0) {
            this.uploadService.uploadfile(this.selectDegreeFile, "");
          }
          if (this.selectRegNoFile.length > 0) {
            this.uploadService.uploadfile(this.selectRegNoFile, "");
          }


          alert("Registration Successfully");
          // $('#newRegisterSecondForm').hide().attr("formnovaildate");
          $('#newRegisterSecondForm').hide().attr("formnovaildate");
          $('#registerUser').hide().attr("formnovaildate");
          $("#otherRegistration").hide().attr("formnovaildate");
          $('#newRegisterFirstForm').toggle();
          this.name = false;
          this.mobileno = false;
          this.userForm = new User();
          this.selectedPincode = "";

          if (this.global.loggedUser.user.role == 'hospital' || this.global.loggedUser.user.role == 'subagent' || this.global.loggedUser.user.role == 'franchise'  || this.global.loggedUser.user.role == 'school' || this.global.loggedUser.user.role == 'corporate'|| this.global.loggedUser.user.role == 'other') {
            this.router.navigate(['doctordashboard']);
          } else if (this.global.loggedUser.user.role == 'patient' || this.global.loggedUser.user.role == null) {
            this.router.navigate(['dashboard']);
          }
          // this.addForm.resetForm();
          // this.addCloseForm.nativeElement.click();
        },
          error => {
            this.spinner.hide()
            alert("User Not Registered");
          });
      this.submitted = false;
      // }

    }
  }

  registerDependentUser() {
    console.log(this.dependentForm);
    this.submitted = true;
    if (this.dependentForm.firstName != '' && this.dependentForm.password != '' && this.dependentForm.confirmpassword != '' && this.dependentForm.gender != '' && this.dependentForm.otp != '' && this.dependentForm.pinCode != '') {
      this.spinner.show()
      var mobilno = this.mobileno;
      // user.firstName = this.name;
      // user.postalAddress = this.selectedPincode;
      // user.pinCode = this.pincode;
      // user.mobileNumber = this.mobileno;
      // user.role ='';
      // console.log(this.user);
      // user.password = this.user.password;
      // this.dependentForm.age = this.age;


      this.dependentForm.mobileNumber = this.mobileno;
      this.dependentForm.role = 'patient'

      this.dependentForm.status = true;
      this.dependentForm.emailAddress = mobilno + "." + this.name.toLowerCase() + "@mdhl.in";
      var firstletter = this.dependentForm.firstName.charAt(0);
      var firstnameupper = firstletter.toLocaleUpperCase();
      var profileImgPath = 'https://mdhl.s3.ap-south-1.amazonaws.com/profileImg/';
      for (let i = 0; i < this.profileImgCharString.length; i++) {
        if (this.profileImgCharString[i].split(".")[0].toString() == firstletter.toLocaleUpperCase()) {
          profileImgPath = profileImgPath + this.profileImgCharString[i];
          break;
        }
      }
      this.dependentForm.profileImgPath = profileImgPath;

      this._userService.registerUser(this.dependentForm)
        .subscribe((response) => {
          this.spinner.hide()
          alert("Registration Successfully");
          $('#dependentuser').hide();
          // $("#addDependentUserModel").modal("hide");
          // $("body").removeClass('modal-open');
          // $('.modal-backdrop').remove();
          //  $('#newRegisterFirstForm').toggle();
          UtilFunctions.setLocalStorage('user', JSON.stringify(response));
          this.router.navigate(['dashboard']);
          this.name = false;
          this.mobileno = false;
          this.dependentForm = new User();
          this.selectedPincode = "";

          // this.addForm.resetForm();
          // this.addCloseForm.nativeElement.click();
        },
          error => {
            this.spinner.hide()
            alert("User Not Register");
          })
      this.submitted = false;
    }

  }

  addDependentuser() {
    //hide toggle
    $('#addDependentUser').hide().attr("formnovaildate");
    $('#registerUser').hide().attr("formnovaildate");
  }



  getpincode(pincode) {
    // debugger
    //  this.pincodefromFont= this.pincodefromFont+""+pincode.key;
    if (pincode.length == 6) {
      this._loginService.GetPincode(pincode).subscribe((response) => {
        // this.pincodeDropDown=response;
        this.pincodeList = response;
        this.filteredOptions = of(this.pincodeList);
        console.log(this.options);
      }, error => {
        this.selectedPincode = "";
      });
    }

  }

  getSelectedPincode(event, check) {
    // $("selectFilter").val(event.option.value.pincode);

    this.pincode = event.option.value.pincode;
    this.selectedPincode = event.option.value.pincode + "-" + event.option.value.postofficenamearea + "," + event.option.value.districtname + "," + event.option.value.statename + " [" + event.option.value.divisionname + "]";

    this.dependentForm.pinCode = this.pincode;
    this.dependentForm.postalAddress = this.selectedPincode;
    this.userForm.pinCode = this.pincode;
    this.userForm.postalAddress = this.selectedPincode;
    console.log(this.selectedPincode);
  }
  ageCalculator(dateofbirth, status) {
    console.log(dateofbirth);

    // var ageCalculator = require('age-calculator');
    // let {AgeFromDateString, AgeFromDate} = require('age-calculator');
    // let { AgeFromDateString } = require('age-calculator');

    // Be careful: Javascript months start at 0 (so zero stands for january)

    // let ageFromDate = new AgeFromDate(new Date(1994,9, 20)).age;
    // console.log("value from AgeFromDate", ageFromDate);
    // output: 30 (at the time of this doc)

    if (status == 'newRegistrationSecondForm') {
      // let ageFromString = new AgeFromDateString(dateofbirth).age;
      let ageFromString = this.getAge(dateofbirth);
      $("#age").val(ageFromString);
      this.userForm.age = ageFromString;

      console.log("value from ageFromString", ageFromString);
    }
    if (status == 'dependantuser') {
      // let ageFromString = new AgeFromDateString(dateofbirth).age;
      let ageFromString = this.getAge(dateofbirth);
      $("#age1").val(ageFromString);
      this.dependentForm.age = ageFromString;

      console.log("value from ageFromString", ageFromString);
    }
    // output: 30 (at the time of this doc)


  }



  getAge(dateString) {
    if(dateString!==""){
    var now = new Date();

    var dob = new Date(dateString.substring(0, 4),
      dateString.substring(5, 7) - 1,
      dateString.substring(8, 10), now.getHours(), now.getMonth(), now.getSeconds()
    );



    //Get difference between years
    var years = now.getFullYear() - dob.getFullYear();
    var currMonth = now.getMonth() + 1;
    var birthMonth = dob.getMonth() + 1;
    var months = 0;
    var days = 0;
    //Get difference between months
    months = currMonth - birthMonth;

    //if month difference is in negative then reduce years by one 
    //and calculate the number of months.
    if (months < 0) {
      years--;
      months = 12 - birthMonth + currMonth;
      if (now.getDate() < dob.getDate())
        months--;
    } else if (months == 0 && now.getDate() < dob.getDate()) {
      years--;
      months = 11;
    }

    //Calculate the days
    if (now.getDate() > dob.getDate())
      days = now.getDate() - dob.getDate();
    else if (now.getDate() < dob.getDate()) {
      var today = now.getMonth();
      now.getMonth(), -1;
      days = now.getMonth() - dob.getMonth() + today;
    }
    else {
      days = 0;
      if (months == 12) {
        years++;
        months = 0;
      }
    }
    //Create new Age object 
    // return new Age(days, months, years);


    if (years > 0) {

      return years + " Years";
    } else if (months > 0) {

      return months + " Months";
    } else {

      return days + " Days";
    }

  }


  }











  checkOtp(opt) {
    this.loginotp = opt;
    if (opt != '') {
      this._loginService.CheckOtp(this.genratedOtp, opt).subscribe((response) => {
        this.otpCheck = response;
        if (this.otpCheck === 'Otp Not Match' || this.otpCheck === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
        }

      }, error => {

      });
    } else {
      return false;
    }
  }
  resendOtp(status, name) {

    this._loginService.GenerateOtp(this.mobileno, name, status).subscribe((response) => {
      this.genratedOtp = response.otp_id;
    }, error => {

    });
  }


  //filter combox  string array


  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  //filter combox  json array

  displayFn(user?: pincode): string | undefined {
    return user ? user.pincode : undefined;
  }

  // private _filter(name: string): pincode[] {
  //   const filterValue = name.toLowerCase();
  //   return this.pincodeList.filter(pincodeList => pincodeList.pincode.toLowerCase().indexOf(filterValue) === 0);
  // }


  LoginSubmit() {
    console.log(this.login);
    this._loginService.VerifyLogin(this.login)
      .subscribe((response) => {
        Object.assign(this.global.loggedUser, response);
        UtilFunctions.setLocalStorage('user', JSON.stringify(response));
        this.router.navigate(['dashboard']);
      }, error => {
        alert("Please Enter Vaild Username and Password");
        console.log(error);
      });
  }


  pincodeDropDown_Added = (term) => ({ pincode: term, name: term });

  forgotUserName() {

    this._loginService.forgotUsername(this.mobileno).subscribe(response => {

      this.nameforForgot = response;
      $("#forgotUsernameModal").modal("show");

    }, error => {

    });
  }

  forgotPassword() {
    this.mobileno;
    var name = "not";
    this.submitted = false;


    $("#namePresent").hide();
    this._loginService.GenerateOtp(this.mobileno, name, "Change Password").subscribe((response) => {
      console.log(response);
      this.genratedOtp = response.otp_id;
    });

    $('#changePassword').toggle();
    $("#otpPresent").hide();
    $("#otpPresentEmergencyContactNo").hide();
    $('#passwordchange').focus();
    $('#dependentuser').hide();


  }

  checkOtpForChangePassword(otp) {
    this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
      this.otpCheck = Response;
      if (this.otpCheck == 'Otp Not Match' || this.otpCheck == 'Expired Otp') {
        alert("Invaild Otp");
      } else {
      }
    });
  }




  ok() {
    $("#forgotUsernameModal").modal("hide");
    $("body").removeClass('modal-open');
    $('.modal-backdrop').remove();
  }
  ChangePassword(password) {
 
    this.submitted = true;
    console.log(this.userForm)
    if (this.userForm.passwordchange != '' && this.userForm.confirmpassword != '' && this.userForm.otp != '') {
      if (this.otpCheck == 'Otp Not Match' || this.otpCheck == 'Expired Otp') {


        info_noti("Invaild Otp")
      }else{

         

  if (this.userForm.passwordchange === this.userForm.confirmpassword) {
    
      this._loginService.passwordChange(password, this.mobileno, this.name).subscribe((response) => {

        if (response == 'Password Change') {
          alert("Password change Successfully");

          this.userForm.passwordchange = '' ;
          this.userForm.confirmpassword= '';
           this.userForm.otp = '';

          // $("#passwordChangemodal").modal("hide");
          // $("body").removeClass('modal-open');
          // $('.modal-backdrop').remove();

          $('#changePassword').hide().attr("formnovaildate");
          this.submitted = false;
          $('#namePresent').show();

        } else {
          alert("Password not change Successfully");
        }
      });
      this.submitted = true;
    }else{
      this.confirmpass = "InVaild Confirm Password"
    }
  }
    
    }
  }


  checkReferralCode(code) {
    this.refrralcode = "";
    debugger;
    if (code) {
      this._loginService.checkReferralCode(code).subscribe((response) => {
        if (response == 'Vaild Referral Code') {
          this.refrralcode = response;
          $("#registerDependentUserBtn").attr("disabled", false);
          $("#registerationNextClickBtn").attr("disabled", false);
        } else {
          this.refrralcode = response;
          $("#registerDependentUserBtn").attr("disabled", true);
          $("#registerationNextClickBtn").attr("disabled", true);
        }
      });
    }
    $("#registerDependentUserBtn").attr("disabled", false);
    $("#registerationNextClickBtn").attr("disabled", false);
  }

  checkConfirmPassword(password, confirmpassword) {
 
  if (password === confirmpassword) {
    this.confirmpass = "Vaild Confirm Password"
    $("#registerDependentUserBtn").attr("disabled", false);
  } else {
    this.confirmpass = "InVaild Confirm Password"
    $("#registerDependentUserBtn").attr("disabled", true);
  }



  }



  // passwordShow(){
  //   this.eyeIcon = this.eyeIcon == "zmdi-eye" ? "zmdi-eye-off" : "zmdi-eye";
  // if( this.eyeIcon =='zmdi-eye-off'){
  //   $('#password').attr('type', 'password');

  // }else{
  //   $('#password').attr('type', 'text');
  // }
  // }

  nexpage(selectvalue) {
    if (selectvalue == 'patient') {
      this.userForm.role = selectvalue;
      $("#registerbutton").show();
      $("#nextbutton").hide();
      $("#othernextbutton").hide();
    } else if (selectvalue == 'doctor') {
      this.userForm.role = selectvalue;
      $("#nextbutton").show();
      $("#othernextbutton").hide();
      $("#registerbutton").hide();

    } else {
      this.userForm.role = selectvalue;
      $("#othernextbutton").show();
      $("#nextbutton").hide();
      $("#registerbutton").hide();
    }



  }
  doctorregisterationNext() {
    this.submitted = true;
    if (this.userForm.password != '' && this.userForm.confirmpassword != '' && this.userForm.otp != '' && this.userForm.gender != '') {
      $('#newRegisterSecondForm').hide();

      $("#doctorRegistration").show();
      this.submitted = false;
    }
  }
  otherregisterationNext() {
    this.submitted = true;
    if (this.userForm.password != '' && this.userForm.confirmpassword != '' && this.userForm.otp != '' && this.userForm.gender != '') {
      $('#newRegisterSecondForm').hide();
      $("#otherRegistration").show();
      this.submitted = false;
    }
  }

  loadEmptyUserForm() {
    this.userForm.firstName = '';
    this.userForm.lastName = '';
    this.userForm.emailAddress = '';
    this.userForm.mobileNumber = '';
    this.userForm.gender = '';
    this.userForm.password = '';
    this.userForm.dob = '';
    
    this.userForm.age = '';
    this.userForm.pinCode = '';
    this.userForm.postalAddress = '';
    this.userForm.middleName = '';
    this.userForm.selectedPincode = '';
    this.userForm.bloodGroup = '';
    this.userForm.userRefCode = '';
    this.userForm.usedRefCode = '';
    this.userForm.confirmpassword = '';
    this.userForm.speciality = '';
    this.userForm.degree = '';
    this.userForm.regno = '';;
    this.userForm.gstno = '';
    this.userForm.panno = '';
    this.userForm.aadharCard = '';
    this.userForm.yearofcommencement = '';
    this.userForm.remark = '';
    this.userForm.aadharno = '';
    this.userForm.otp = '';
    this.userForm.other = '';
    this.userForm.degreeCertificatePath = '';
    this.userForm.regnoCertificatePath = '';
    this.userForm.healthCardIssueText = '';
    this.userForm.healthCardIssueReferalText = '';
  }
  loadEmptyDependentForm() {
    this.dependentForm.firstName = '';
    this.dependentForm.lastName = '';
    this.dependentForm.emailAddress = '';
    this.dependentForm.mobileNumber = '';
    this.dependentForm.gender = '';
    this.dependentForm.password = '';
    this.dependentForm.dob = '';

    this.dependentForm.age = '';
    this.dependentForm.pinCode = '';
    this.dependentForm.postalAddress = '';
    this.dependentForm.middleName = '';
    this.dependentForm.selectedPincode = '';
    this.dependentForm.bloodGroup = '';
    this.dependentForm.userRefCode = '';
    this.dependentForm.usedRefCode = '';
    this.dependentForm.confirmpassword = '';
    this.dependentForm.speciality = '';
    this.dependentForm.degree = '';
    this.dependentForm.regno = '';;
    this.dependentForm.gstno = '';
    this.dependentForm.panno = '';
    this.dependentForm.aadharCard = '';
    this.dependentForm.yearofcommencement = '';
    this.dependentForm.remark = '';
    this.dependentForm.aadharno = '';
    this.dependentForm.otp = '';
    this.dependentForm.other = '';
    this.dependentForm.degreeCertificatePath = '';
    this.dependentForm.regnoCertificatePath = '';
    this.dependentForm.healthCardIssueText = '';
    this.dependentForm.healthCardIssueReferalText = '';
  }
  onFileChange(event, status) {
    if (status === 'degree') {
      this.selectDegreeFile = event.target.files;
      // console.log(event.target.files);
      if (this.selectDegreeFile.length > 0) {
        this.userForm.degreeCertificatePath = this.selectDegreeFile[0].name;
      }
    } else if (status === 'regno') {
      this.selectRegNoFile = event.target.files;
      if (this.selectRegNoFile.length > 0) {
        this.userForm.regnoCertificatePath = this.selectRegNoFile[0].name;
      }
    }

  }
  selected(event, check) {
    if (check === 'gender') {
      this.userForm.gender = event;
    }

    if (check === 'bloodgroup') {
      this.userForm.bloodGroup = event;
    }
    if (check === 'dependent') {

      this.dependentForm.gender = event;
    }

    if (check === 'dependentbloodgroup') {
      this.dependentForm.bloodGroup = event;
    }

  }



  //Enter pressed and focus textbox events
  loginpasswordEnter() {
    $('#loginbtn').focus();
    this.LoginClick('passwordlogin');
  }

  loginOtpEnter(otp) {

    if (otp != '') {
      this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
        if (response === 'Otp Not Match' || response === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
          info_noti("Otp Not Match");
          return false;
        } else {
          this.LoginClick('otpLogin');
          $('#loginbtnforOtp').focus();
          $('#loginbtnforOtpEmergencyContactNo').focus();

        }

      }, error => {

      });
    }
  }

  loginOtpEmergencyContactEnter(otp) {
    if (otp != '') {
      this._loginService.CheckOtp(this.genratedOtp, otp).subscribe((response) => {
        if (response === 'Otp Not Match' || response === 'Expired Otp') {
          //  alert("Otp Not Match")
          this.otpCheck = response;
          info_noti("Otp Not Match");
          return false;
        } else {
          this.LoginClick('otpLogin');
          $('#loginbtnforOtpEmergencyContactNo').focus();

        }

      }, error => {

      });
    }
  }










  //register for password

  
  passwordMiddleNameEnter() {
    $('#lastNameforpassword').focus();
  }
  passwordLastNameEnter() {
    $('#emailIdforpassword').focus();
  }
  passwordEmailIdEnter() {
    $('#usedRefCodeforPassword').focus();
  }
  passwordReferalCodeEnter() {
    $('#pincodeforPassword').focus();
  }
  passwordPincodeEnter() {
    $('#registrationNextBtn').focus();
  }
  //register new user


  firstName1ForRegisterUserEnter() {
    $('#middleNameForRegisterUser').focus();
  }
  middleNameForRegisterUserEnter() {
    $('#lastNameForRegisterUser').focus();
  }
  lastNameForRegisterUserEnter() {
    $('#emailIdForRegisterUser').focus();
  }
  emailIdForRegisterUserEnter() {
    $('#userRefCodeForRegisterUser').focus();
  }
  userRefCodeForRegisterUserEnter() {
    $('#pincodeForRegisterUser').focus();
  }
  pincodeForRegisterUserEnter() {
    console.log("click Enter");
    $('#registerationNextClickBtn').focus();

    this.registerationNextClick();

  }


  //doctor register
  specialityEnter() {
    $('#degree').focus();
  }
  degreeEnter() {
    $('#regno').focus();
  }
  regnoEnter() {
    $('#degreefile').focus();
  }
  degreefileEnter() {
    $('#regnofile').focus();
  }
  regnofileEnter() {
    $('#gstno').focus();
  }
  gstnoEnter() {
    $('#panno').focus();
  }
  pannoEnter() {

    $('#aadharno').focus();
  }

  aadharnoEnter() {
    $('#yearofcommencement').focus();
  }
  yearofcommencementEnter() {
    $('#remark').focus();
  }
  remarkEnter() {
    $('#helathcardissuetext').focus();
  }

  helathcardissuetextEnter() {
    $('#registerDoctor').focus();
  }
  //other registration
  otherspecialityEnter() {
    $('#otherdegree').focus();
  }
  otherdegreeEnter() {
    $('#otherregno').focus();
  }
  otherregnoEnter() {
    $('#otherdegreefile').focus();
  }
  otherdegreefileEnter() {
    $('#otherregnofile').focus();
  }
  otherregnofileEnter() {
    $('#othergstno').focus();
  }

  othergstnoEnter() {
    $('#otherpanno').focus();
  }
  otherpannoEnter() {
    $('#otheraadharno').focus();
  }
  otheraadharnoEnter() {
    $('#otheryearofcommencement').focus();
  }
  otheryearofcommencementEnter() {
    $('#otherremark').focus();
  }
  otherremarkEnter() {
    $('#otherhelathcardissuetext').focus();
  }
  otherhelathcardissuetextEnter() {
    $('#registerOther').focus();
  }

  //second form register

  passwordNewRegisterEnter() {
    $('#confirmpasswordForNewRegister').focus();
  }
  confirmpasswordForNewRegisterEnter() {
    $('#otpForNewRegister').focus();
  }
  otpForNewRegisterrEnter() {
    $('#dobForNewRegister').focus();
    // $('#dobForNewRegisterForMobile').focus();
  }
  dobForNewRegisterEnter() {
    $('#ageForNewRegister').focus();
  }
  // dobForNewRegisterEnterForMobile() {
  //   $('#ageForNewRegister').focus();
  // }
  ageForNewRegisterEnter() {
    $('#genderForNewRegister').focus();
  }
  genderForNewRegisterEnter() {
    $('#bloodgruopForNewRegister').focus();
  }
  bloodgruopForNewRegisterEnter() {
    $('#confirmpasswordForPasswordChange').focus();
  }
  doctorORPatientForNewRegisterEnter() {
    // $('#confirmpasswordForPasswordChange').focus(); 
  }
  // registerbutton
  // nextbutton
  //dependent register
  firstName2Enter() {
    $('#middlename2').focus();
    // $('#dobForDepentdentForMobile').focus();

  }
  middleName2Enter() {
    $('#lastname2').focus();
    // $('#dobForDepentdentForMobile').focus();

  }
  lastName2Enter() {
    $('#dobForDepentdent').focus();
    // $('#dobForDepentdentForMobile').focus();

  }
  dobForDepentdentEnter() {
    $('#ageForDepentdent').focus();

  }
  // dobForDepentdentEnterForMobile(){
  //   $('#ageForDepentdent').focus();
  // }
  ageForDepentdentEnter() {
    $('#passwordForDependent').focus();
  }
  passwordForDependentEnter() {
    $('#confirmpasswordForDependent').focus();
  }
  confirmpasswordForDependentEnter() {
    $('#bloodgroupForDependent').focus();
  }
  bloodgroupForDependentEnter() {
    $('#genderForDependent').focus();
  }
  genderForDependentEnter() {
    $('#usedRefCodeForDepentdent').focus();
  }
  usedRefCodeForDepentdentEnter() {
    $('#otpFordependent').focus();
  }
  otpFordependentEnter() {
    $('#pincodeFordependent').focus();
  }
  pincodeFordependentEnter() {
    $('#registerDependentUserBtn').focus();
  }

  //change password
  passwordchangeEnter() {
    $('#confirmpasswordForPasswordChange').focus();
  }
  confirmpasswordForPasswordChangeEnter() {
    $('#otpchangePassword').focus();
  }
  otpchangePasswordEnter() {
    $('#changePasswordBtn').focus();
  }
  dependentemailAddress1Enter() { }
  // passwordchange

  //word count
  wordCount(type) {
    if (type == "doctor") {
      var value = $('#helathcardissuetext').val();
      if (value.length == 0) {
        $('#doctordisplay_count').html(0);

        return;
      }
      var charCount = value.length;
      $('#doctordisplay_count').html(charCount);
    } else {
      var value = $('#otherhelathcardissuetext').val();
      if (value.length == 0) {
        $('#otherdisplay_count').html(0);

        return;
      }
      var charCount = value.length;
      $('#otherdisplay_count').html(charCount);
    }

   

    // $(document).ready(function() {
    //   $("#healthcardissue").on('keydown', function(e) {
    //       // var words = $.trim(this.value).length ? this.value.match(/\S+/g).length : 0;
    //       var words = $.trim(this.value).length ? this.value.match().length : 0;
    //       if (words <= 38) {
    //           $('#display_count').text(words);
    //           //$('#word_left').text(5-words)
    //       }else{
    //           if (e.which !== 8)
    //           {
    //             e.preventDefault();
    //           }
    //       }
    //   });
    // });

  }

  dobBlur(dob,status) {
    debugger
    this.ageCalculator(dob,status);
    // info_noti('Age Calculation Mandatory Please Calculate Age');
  }
}

// export interface User {
//   name: string;
// }
export class Gender {
  genderId: number;
  name: string;
}

export class Age {
  years: number;
  months: number;
  days: number;
}